import { render } from "./AssignCustomerDialog.vue?vue&type=template&id=51d08f82&scoped=true"
import script from "./AssignCustomerDialog.vue?vue&type=script&lang=js"
export * from "./AssignCustomerDialog.vue?vue&type=script&lang=js"

import "./AssignCustomerDialog.vue?vue&type=style&index=0&id=51d08f82&lang=scss&scoped=true"
import "./AssignCustomerDialog.vue?vue&type=style&index=1&id=51d08f82&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d08f82"]])

export default __exports__